import { render, staticRenderFns } from "./ShowBidTotalComponent.vue?vue&type=template&id=3dec6908&"
import script from "./ShowBidTotalComponent.vue?vue&type=script&lang=js&"
export * from "./ShowBidTotalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports